import React from "react";
import ReportComponent from "./ReportComponent";
export default function Report() {

    return (
      <React.Fragment>
        <ReportComponent />
      </React.Fragment>
    )
}